import { push } from 'connected-react-router';
import { get, isEmpty } from 'lodash';

import { getLayouts } from 'common/api/v1/layouts';
import { getParentFieldSegments } from 'common/components/segment/helpers';
import { PROPOSAL_STATUS } from 'common/constants';

import {
    FETCH_OFFER_INFO_PATERN_SUCCESS,
    FETCH_OFFER_PANELS_SUCCESS,
    FETCH_PARENT_FIELD_SEGMENT,
    FETCH_PARENT_FIELD_SEGMENT_FAILURE,
    FETCH_PARENT_FIELD_SEGMENT_SUCCESS,
} from '../actionTypes';
import { panelLayoutV2Actions } from '../reducer';

import setIsDisabledEdition from './setIsDisabledEdition';

export default (id) => (dispatch) => {
    const parentId = id;

    return new Promise((resolve) => {
        dispatch(panelLayoutV2Actions[FETCH_PARENT_FIELD_SEGMENT]());

        getLayouts(parentId)
            .then((response) => {
                const layout = get(response, 'data.data', {});

                if (isEmpty(layout)) {
                    dispatch(push(`/proposal/${id}`));
                    return false;
                }

                const {
                    altitude,
                    address,
                    id,
                    latitude,
                    longitude,
                    proposal,
                    segments,
                    tr50_cfe20,
                    tr_10_cfe20,
                } = layout;

                const location = {
                    address,
                    id: parentId,
                    latitude,
                    longitude,
                };

                const { project, render_status: renderStatus } = proposal;

                const offerInfoPatern = {
                    altitude,
                    contactId: project.contact.id,
                    contactName: project.contact.name,
                    projectId: project.id,
                    projectName: project.name,
                    proposalId: proposal.id,
                    renderStatus,
                    tr_10_cfe20,
                    tr50_cfe20,
                };

                if (renderStatus === PROPOSAL_STATUS.GENERATED) {
                    dispatch(setIsDisabledEdition(true));
                }

                const { newSegments, panels } = getParentFieldSegments(
                    segments,
                    parentId,
                );

                dispatch(
                    panelLayoutV2Actions[FETCH_PARENT_FIELD_SEGMENT_SUCCESS]({
                        id,
                        location,
                        proposal,
                        segments: newSegments,
                    }),
                );

                dispatch(
                    panelLayoutV2Actions[FETCH_OFFER_PANELS_SUCCESS]({
                        panels,
                    }),
                );

                dispatch(
                    panelLayoutV2Actions[FETCH_OFFER_INFO_PATERN_SUCCESS](
                        offerInfoPatern,
                    ),
                );
            })
            .catch((error) => {
                dispatch(
                    panelLayoutV2Actions[FETCH_PARENT_FIELD_SEGMENT_FAILURE](
                        error?.response?.data?.errors,
                    ),
                );
            })
            .finally(resolve);
    });
};
